export default [
  {
    path: '/projects/:projectId(\\d+)/people/teams/:teamId(\\d+)/:teamPageTab?',
    component: () => import('./RouteProjectsPeopleTeams.vue'),
  },
];
